import { Modal } from "antd";
import EditCompanyForm from "components/EditCompanyForm/EditCompanyForm";
import { Company } from "interfaces/companies";
import React from "react";

interface EditCompanyModalProps {
  company: Company;
  open: boolean;
  onClose: () => void;
  onSave: (company: Company) => void;
}

const EditCompanyModal: React.FC<EditCompanyModalProps> = ({ company, open, onClose, onSave }) => {
  const handleSave = (c: Company) => {
    onSave(c);
    onClose();
  };

  return (
    <Modal open={open} title="Oppdater bedrift" onCancel={onClose} footer={null} width="80%">
      <EditCompanyForm company={company} onSave={handleSave} />
    </Modal>
  );
};

export default EditCompanyModal;
